import { IconEyeOff, IconGhost, IconMoodCrazyHappy } from '@tabler/icons-react';

/**
 * FAQ data for the name generator page.
 */
export const NAME_GEN_FAQ = [
    { id: 'detect', question: 'Can teachers detect these names?', answer: 'Stealth names (like "Student") blend in perfectly. Glitch names might attract attention but are hard to read.', icon: IconEyeOff, color: 'gray' },
    { id: 'invisible', question: 'How does the Invisible Name work?', answer: 'We use a "Zero Width Joiner" character. It looks empty to the human eye, but the Kahoot server accepts it.', icon: IconGhost, color: 'grape' },
    { id: 'limit', question: 'Is there a limit?', answer: 'No limit! Generate as many as you want.', icon: IconMoodCrazyHappy, color: 'pink' }
];